import { AWS_API_URL } from 'global/environment';
import { authorize, putRequest } from 'utils/http';
import { mapDataForBackend } from './mapData';

export async function updateLightningGroupAPI(data) {
  return putRequest(`${AWS_API_URL}/lighting/group/${data?.group?.value}`,
    mapDataForBackend(data), await authorize());
}
